module.exports = __webpack_public_path__ + "resources/img/img_watchall_nms2_en.d3a35c43a6a23ff57f5c87d019a3c9f1.png";